import { Box, Text, Heading, Flex, Image, Button, SimpleGrid } from '@chakra-ui/react'
import Layout from '../layout'
import vehicleImage from '../multimedia/imagenes/pagacuotas.jpg'
import callImage from '../multimedia/imagenes/call2.jpeg'
import icon1 from '../multimedia/icons/1.png'
import icon2 from '../multimedia/icons/2.png'
import icon3 from '../multimedia/icons/3.png'
import icon4 from '../multimedia/icons/4.png'
import icon5 from '../multimedia/icons/5.png'
import icon6 from '../multimedia/icons/6.png'
import MiniCard from "../components/MiniCard"
import { Link } from 'react-router-dom/cjs/react-router-dom'


const Requisitos = () => {

    return (
        <Layout>


            <Flex maxW={"2000px"} margin={"auto"} flexDir={{ base: 'column', md: 'row' }}>
                <Box order={{ base: 2, md: 1 }} className={'sideLeft'} w={"full"} maxW={{ base: "full", md: "50%" }} pl={"5%"} m={"auto"} >
                    <Box flex={1} p={"10"} margin={"auto"} >
                        <Heading>Paga tu vehículo mensualmente con nuestro arrendamiento financiero</Heading>
                        <Text>Conoce todos los requisitos para aplicar.</Text>
                        <Link to={`/cotizar`}>
                            <Button colorScheme='easycar1'>Págalo mensualmente</Button>
                        </Link>
                    </Box>
                </Box>
                <Box order={{ base: 1, md: 2 }} className={'sideRight'} w={"full"} maxW={{ base: "full", md: "50%" }}>
                    <Image alt={'Conduciendo'} objectFit='cover' src={vehicleImage} />
                </Box>
            </Flex>

            <Box textAlign="center" maxW="1400px" margin="auto" mt="7.5rem" mb="2rem">
                <Heading mt="20px">Pasos para arrendamiento financiero</Heading>

                <Flex justifyContent="center" mt="10" bg="white" pt="100px" pb="100px">
                    <SimpleGrid
                        columns={{ base: 1, md: 2, lg: 3 }} // móvil: 1 columna, mediano: 2 columnas, desktop: 3 columnas
                        spacing={10}
                        maxW="1200px" // límite para que se centre bien
                    >
                        <MiniCard
                            icon={<Image className='miniCarIcon' src={icon1} alt="Paso 1: Selecciona tu vehículo" boxSize={28} />}
                            title="Paso 1: Selecciona tu vehículo"
                            content="Te proporcionamos una amplia variedad de vehículos para que puedas seleccionar dentro de nuestro catálogo."
                        />

                        <MiniCard
                            icon={<Image className='miniCarIcon' src={icon2} alt="Paso 2: Contacta a un ejecutivo" boxSize={28} />}
                            title="Paso 2: Contacta a un ejecutivo"
                            content="Te proporcionamos toda la información que necesitas del vehículo, sus condiciones y requisitos para que puedas adquirirlo sin preocupaciones."
                        />

                        <MiniCard
                            icon={<Image className='miniCarIcon' src={icon3} alt="Paso 3: Agenda tu prueba de manejo" boxSize={28} />}
                            title="Paso 3: Agenda tu prueba de manejo"
                            content="Prueba el vehículo de tu interés, inspecciónalo a detalle y comprueba personalmente su óptimo estado antes de decidirte."
                        />

                        <MiniCard
                            icon={<Image className='miniCarIcon' src={icon4} alt="Paso 4: Paga el anticipo" boxSize={28} />}
                            title="Paso 4: Paga el anticipo"
                            content="Realiza el pago del anticipo correspondiente; si no cuentas con el monto completo en el momento, puedes reservarlo para asegurar que no se continúe comercializando."
                        />

                        <MiniCard
                            icon={<Image className='miniCarIcon' src={icon5} alt="Paso 5: Completa la documentación" boxSize={28} />}
                            title="Paso 5: Completa la documentación"
                            content="Acércate a una de nuestras sucursales para completar todo el proceso de documentación necesario."
                        />

                        <MiniCard
                            icon={<Image className='miniCarIcon' src={icon6} alt="Paso 6: Llévatelo" boxSize={28} />}
                            title="Paso 6: Llévatelo"
                            content="Empieza a disfrutar tu experiencia EASYCAR."
                        />
                    </SimpleGrid>
                </Flex>
            </Box>


            <Box w={"full"} >
                <Flex bg={'gray.100'} maxW={"1400px"} flexDir={{ base: 'column', md: 'row' }} p={4} m={"auto"} mt={"7.5rem"}>
                    <Box flex={1} p={"10"} margin={"auto"} >
                        <Heading>Aprobamos tu plan de pago con la mejor asesoría</Heading>
                        <br />
                        <Text>Contamos con ejecutivos/as personalizados que te acompañarán en todo el proceso.</Text>
                        <br />
                        <Link to={`/cotizar`}>
                            <Button colorScheme='easycar2'>Adquiere tu vehículo en arrendamiento financiero</Button>
                        </Link>
                    </Box>
                    <Box flex={1} alignItems={"center"} justifyContent={"center"} margin={"auto"}>
                        <Image alt={'Call center'} height={"500px"} width={"auto"} src={callImage} margin={"auto"} />
                    </Box>

                </Flex>
            </Box>
        </Layout>
    )

}

export default Requisitos